// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"238":"inscricoes","535":"login"}[chunkId] + "." + {"238":"672d5cd3","535":"c0a7041c"}[chunkId] + ".css";
};